/* eslint-disable */

import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { pairAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type ClaimLpFeesProps = {
  account: Address
  chainId: number
  config: Config
  pairAddress: Address
}

export const claimLpFees = async ({
  account,
  chainId,
  config,
  pairAddress,
}: ClaimLpFeesProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: pairAbi as Abi,
        account,
        address: pairAddress,
        args: [],
        chainId,
        functionName: "claimFees",
      },
    })
    return result
  } catch (error: any) {
    console.error("claimFees", error)
    return { success: false, error: error.message, code: error.code }
  }
}
